import { RESET_REG_FLOW, SET_BASIC_INFO, SET_ADDRESS, SET_PHONE_NUMBER, SET_IMAGE_INFO, SET_RETURN_TO } from '../actions/action-types/registration-actions'

import { trackEvent } from '../analytics/tracking';

const initState = {
  name /* first+last */: '',
  email: '',
  password: '',
  street_address: '',
  city: '',
  state: 'MA',
  zip_code: '',
  apartment_number: '',
  dob: {
    month: '',
    day: '',
    year: '',
  },
  tel_number: '',
  photo_ids: {
    primary: {
      path: '',
      url: ''
    },
    secondary: {
      path: '',
      url: ''
    }
  },
  terms_accepted: false,
  marketing_accepted: true,
  return_to_path: ''
};

const registrationReducer = (state = initState, action) => {
  
  // first log action - ignore init
  if (action.type && action.type.indexOf('@@redux') === -1) {
    // action, type (context), id (here it's zipcode)
    const id = state.zip_code || 'no_zip_code';
    trackEvent( action.type, 'registration', id, []);
  }
  
  // Set customer's basic info, name, address etc.
  if (action.type === SET_BASIC_INFO){
    if (action.basicInfo.accept_marketing) {
      trackEvent('marketing_opt_in', 'registration');
    } else {
      trackEvent('marketing_opt_out', 'registration');
    }
    return {
      ...state,
      name: action.basicInfo.name,
      email: action.basicInfo.email,
      password: action.basicInfo.password,
      apartment_number: action.basicInfo.apartment_number,
      dob: action.basicInfo.dob,
      terms_accepted: action.basicInfo.accept_terms,
      marketing_accepted: action.basicInfo.accept_marketing
    }  
    // Set customer's address only, e.g. via typeahead
  } else if (action.type === SET_ADDRESS) {
    return {
      ...state,
      street_address: action.location.street_address,
      city: action.location.city,
      state: action.location.state,
      zip_code: action.location.zip_code
    }   
    // Set customer's phone number
  } else if (action.type === SET_PHONE_NUMBER) {
    return {
      ...state,
      tel_number: action.tel_number
    }   
  // Set customer's ID images ( front/back )
  } else if (action.type === SET_IMAGE_INFO) {
    return {
      ...state,
      photo_ids: action.photo_ids
    }
  // Save the path to return to after registration (provided via signUp?returnTo=)
  } else if (action.type === SET_RETURN_TO) {
    return {
      ...state,
      return_to_path: action.return_to_path 
    }
  } else if (action.type === RESET_REG_FLOW) {
    return {
      ...initState,
    }
  } else {
    return state;
  }
}

export default registrationReducer;
